import React from 'react';
import { History, ChevronRight } from 'lucide-react';

export default function SessionHistory({ history, currentIndex, onRollback }) {
  if (!history || history.length <= 1) return null;
  return (
    <div className="fs-history">
      <div className="fs-history-title"><History size={13} /> Query Versions</div>
      {history.map((entry, i) => (
        <button
          key={i}
          className={`fs-history-item ${i === currentIndex ? 'fs-history-item--current' : ''}`}
          onClick={() => i !== currentIndex && onRollback(i)}
          disabled={i === currentIndex}
        >
          <ChevronRight size={11} />
          <span className="fs-history-label">
            {i === 0 ? 'Initial query' : `Refinement v${i}`}
          </span>
          <span className="fs-history-meta">
            {new Date(entry.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </span>
        </button>
      ))}
    </div>
  );
}
